<template>
  <footer class="app-footer">
    <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer" class="icp-link">
      闽ICP备17004323号-7
    </a>
    <a
      href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=35010402351827"
      target="_blank"
      rel="noopener noreferrer"
      class="icp-link"
    >
      闽公网安备35010402351827号
    </a>
  </footer>
</template>

<script setup lang="ts">
defineOptions({
  name: 'AppFooter',
});
</script>

<style scoped lang="scss">
.app-footer {
  text-align: center;
  padding-bottom: 8px;
  font-size: 12px;
  color: #9aa8bd;
}

.icp-link {
  color: inherit;
  text-decoration: none;
  transition: color 0.2s;
  padding: 0 8px;

  &:hover {
    color: #409eff;
  }
}
</style>
